export default {
  "application/pdf": "icn_pdf.svg",
  "application/x-pdf": "icn_pdf.svg",
  "image/vnd.adobe.photoshop": "icn_psd.svg",
  "application/msword": "icn_doc.svg",
  "application/vnd.oasis.opendocument.text": "icn_doc.svg",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "icn_doc.svg",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": "icn_doc.svg",
  "application/vnd.ms-excel": "icn_xlm.svg",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "icn_xlm.svg",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": "icn_xlm.svg",
  "application/zip": "icn_zip.svg",
  "application/gzip": "icn_zip.svg",
  "application/x-tar": "icn_zip.svg",
  "application/x-7z-compressed": "icn_zip.svg",
  "application/vnd.audiograph": "icn_aep.svg",
  "application/postscript": "icn_ai.svg",
  "text/javascript": "icn_html.svg",
  "text/html": "icn_html.svg",
  "text/css": "icn_html.svg",
  "text/markdown": "icn_html.svg",
  "font": "icn_font.svg",
  "audio": "icn_mp3.svg",
  "video": "icn_video.svg",
  "generic": "generic-file.svg"
}